import wretch from 'wretch';
import { guardMiddleware, sinkMiddleware, timeoutMiddleware } from '@/api/interceptors';

export const client = wretch('/', { mode: 'same-origin' }).middlewares([
  sinkMiddleware(),
  timeoutMiddleware({ timeoutMs: 10_000 }),
  guardMiddleware(),
]);

export const clusterDashboardClient = wretch(undefined, { mode: 'cors', credentials: 'include' }).middlewares([
  sinkMiddleware(),
  timeoutMiddleware({ timeoutMs: 10_000 }),
  guardMiddleware(),
]);

// A serverless space's REST endpoint authenticates by `api-key` header, so it sends no cookies.
export const spaceDataClient = wretch(undefined, { mode: 'cors' }).middlewares([
  sinkMiddleware(),
  timeoutMiddleware({ timeoutMs: 10_000 }),
  guardMiddleware(),
]);
